import { httpClient } from "./httpClient";

type VIP = {
    id: number;
    vipEmail: string;
    void: boolean;
    active: boolean;
    approverEmail: string;
};

type Data = {
  vips: VIP[];
};

type DataPaginated = {
  vips: VIP[];
  totalCount: number;
};

export async function getVIPs(): Promise<VIP[]> {
  try {
    const { data } = await httpClient.get<Data>(`/api/v1/vips`);

    return data.vips;
  } catch (error) {
    throw error;
  }
}

export async function getVIPById(id: number): Promise<VIP> {
  try {
    const { data } = await httpClient.get<VIP>(`/api/v1/vips/${id}`);

    return data;
  } catch (error) {
    throw error;
  }
}

export async function getPaginatedVIPs(page: number, perPage: number, where: string): Promise<DataPaginated> {
  try {
    // 0 = page 1, 1 = page 2 etc.
    const { data } = await httpClient.get<DataPaginated>(`/api/v1/vipspaginated/${page}/${perPage}/searchemail?email=${where}`);

    return data;
  } catch (error) {
    throw error;
  }
}

export async function getVIPByEmail(email?: string): Promise<VIP> {
  try {
    const { data } = await httpClient.get<VIP>(
      `/api/v1/vips${email ? `/searchemail?email=${email}` : ``}`
    );

    return data;
  } catch (error) {
    throw error;
  }
}
